export default "__VITE_PUBLIC_ASSET__2071de04__"